import {
  BillInfo,
  BillType,
  BillStatus,
  TransactionStatus,
  BillFileInfo,
  CreditStatus,
} from "..";
import { client } from "../../client";

export type BillProps = {
  isDunning: boolean;
  isFinal: boolean;
  isDirty: boolean;
  isDirtyCleared: boolean;
  isConsolidated: boolean;
  isUnderReview: boolean;
  isDunningSuppressed: boolean;
  isPaymentPlan: boolean;
  isSuperseded: boolean;
  isBelowMin: boolean;
};

export interface BillDetails extends BillInfo {
  fromDttm: string;
  toDttm: string;
  status: BillStatus | CreditStatus;
  type: BillType;
  files: BillFileInfo[];
  billProps: BillProps | null;
}

export type BreakdownLine = {
  id: string;
  type: string;
  description: string;
  amount: string;
  currency: string;
};

export type BreakdownGroup = {
  assetType: string | null;
  meterPointerIdentifier: string | null;
  breakdownLines: BreakdownLine[];
};

export interface BillExtendedDetails extends BillDetails {
  collectionDt: string | null;
  collectionRequestDt: string | null;
  balance: string;
  draftReason: string | null;
  resolvedDttm: string | null;
  transactionStatus: TransactionStatus;
  breakdownGroups: BreakdownGroup[];
}

export interface CreditExtendedDetails extends BillDetails {
  billNumber: string | null;
  reason: string | null;
  resolvedDttm: string | null;
  transactionStatus: TransactionStatus | null;
  breakdownGroups: BreakdownGroup[];
}

export interface AccountBills {
  results: BillDetails[];
}

export const getAccountBills = (
  key: string,
  {
    page,
    size,
    accountNumber,
  }: { page: number; size: number; accountNumber: string },
) => {
  const params = { page: String(page), size: String(size) };
  return client
    .get<AccountBills>(
      `accounts/${accountNumber}/bills?${new URLSearchParams(
        params,
      ).toString()}`,
    )
    .then((response) => {
      return {
        results: response?.data?.results,
        totalCount: response?.headers["x-total-count"],
      };
    });
};

export const getAccountBill = (
  key: string,
  { accountNumber, billNumber }: { accountNumber: string; billNumber: string },
) => {
  return client
    .get<BillExtendedDetails>(`accounts/${accountNumber}/bills/${billNumber}`)
    .then((res) => {
      return res.data;
    });
};

export const getAccountCredit = (
  key: string,
  {
    accountNumber,
    creditNumber,
  }: { accountNumber: string; creditNumber: string },
) => {
  return client
    .get<CreditExtendedDetails>(
      `accounts/${accountNumber}/credits/${creditNumber}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const getChipCount = (billProps: BillProps) =>
  Object.keys(billProps).filter(
    (k) =>
      k !== "isSuperseded" &&
      k !== "isDunningSuppressed" &&
      billProps[k as keyof BillProps] === true,
  ).length;
